/**
 * Created by zhaoy on 2020/07/11
 * Desc: 学生名单
 */

export default function InOutBean() {
    this.lack = 0 //缺勤
    this.total = 0 //总数
    this.skaForLeave = 0 //请假
    this.clock = 0 //打卡
    this.residence = 0 //住宿
    this.rosterList = [] //学生

}